import React from 'react';
import FixedTopBarScholarship from './FixedTopBarScholarshipUI';

export const FixedTopBarScholarshipScheduleNOffline = props => {
  return <FixedTopBarScholarship data={[]} {...props} />;
};

export default FixedTopBarScholarshipScheduleNOffline;
